import { ReactElement } from 'react';
import { Tooltip } from '@common-components';
import { useTooltipVideoPlayer } from './useTooltipVideoPlayer';

interface TooltipVideoPlayerProps {
  children: ReactElement;
  videoUrl?: string;
}

export function TooltipVideoPlayer({ children, videoUrl }: TooltipVideoPlayerProps) {
  const { videoRef, handleTooltipOpen, handleTooltipClose, handleVideoLoad } = useTooltipVideoPlayer();

  if (!videoUrl) {
    return children;
  }

  return (
    <Tooltip
      placement="left"
      adjustSizeToContent
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      tooltipContent={
        <video
          ref={videoRef}
          src={videoUrl}
          preload="auto"
          loop
          muted
          playsInline
          onLoadedData={handleVideoLoad}
          style={{
            width: '50vw',
          }}
        >
          Your browser does not support the video tag.
        </video>
      }
    >
      {children}
    </Tooltip>
  );
}
